module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#next-story",
      toString: function () {
        return this.url;
      }
    }